import { type MutationPayload } from 'vuex';
import Store from '../stores/store';
import { UrlModuleConstant } from '../constants';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

const { action, name } = UrlModuleConstant;

export default class UrlStore implements ltFramework.IUrlStore {
	public getInitialData(): ltFramework.IUrl {
		return (Store.state as ltFramework.IStoreState).urlModule.url;
	}

	public initialize(): Promise<void> {
		return Store.dispatch(name + '/' + action.initialize);
	}

	public listen(callback: (state: ltFramework.IUrl) => void): () => void {
		return Store.subscribe((mutation: MutationPayload, state: ltFramework.IRootState) => {
			if (mutation.type.includes(name + '/')) {
				callback((state as ltFramework.IStoreState).urlModule.url);
			}
		});
	}

	public updateUrl(href: string): Promise<void> {
		return Store.dispatch(name + '/' + action.updateUrl, href);
	}

	public urlUpdated(): Promise<void> {
		return Store.dispatch(name + '/' + action.urlUpdated);
	}
}
